<template>
  <div v-if="wechatGroup || guideInfo || (qrCode && qrCode.src !== '')"
       class="product-detail-member-notice"
  >
    <div class="product-detail-member-notice-receive-info">
      <div v-if="wechatGroup || (qrCode && qrCode.src !== '')"
           class="product-detail-member-notice-receive-info-block-title"
      >
        重要 | 课前准备
      </div>
      <div v-if="wechatGroup && qrCode && qrCode.src !== ''"
           class="product-detail-member-notice-receive-info-square-container"
      >
        <div class="product-detail-member-notice-receive-info-square-qr-code"
             @click="handleClickQrCode"
             v-ym-report:OPEN_WECHAT_NOTICE_PROMPT_BTN_CLICK="{
               targetId: id,
               targetType: type,
               type,
             }"
        >
          <div class="block-title">重要信息提醒</div>
          <div class="block-desc">开启通知，掌握即时消息</div>
          <div class="block-action">马上开启</div>
        </div>
        <div class="product-detail-member-notice-receive-info-square-wechat-group"
             @click="handleClickWeChatGroup"
             v-ym-report:JOIN_GROUP_PROMPT_BTN_CLICK="{
               targetId: id,
               targetType: type,
               type,
             }"
        >
          <div class="block-title">课程学习群</div>
          <div class="block-desc">为保证学习进度，请务必进群</div>
          <div class="block-action">立即进群</div>
        </div>
      </div>
      <div v-else-if="wechatGroup"
           class="product-detail-member-notice-receive-info-rect-container"
      >
        <div class="product-detail-member-notice-receive-info-rect-wechat-group"
             @click="handleClickWeChatGroup"
             v-ym-report:JOIN_GROUP_PROMPT_BTN_CLICK="{
               targetId: id,
               targetType: type,
               type,
             }"
        >
          <div class="left-block">
            <div class="left-block-title">课程学习群</div>
            <div class="left-block-desc">为保证学习进度，请务必进群</div>
          </div>
          <div class="right-block">立即进群</div>
        </div>
      </div>
      <div v-else-if="qrCode && qrCode.src !== ''"
           class="product-detail-member-notice-receive-info-rect-container"
      >
        <div class="product-detail-member-notice-receive-info-rect-qr-code-group"
             @click="handleClickQrCode"
             v-ym-report:OPEN_WECHAT_NOTICE_PROMPT_BTN_CLICK="{
               targetId: id,
               targetType: type,
               type,
             }"
        >
          <div class="left-block">
            <div class="left-block-title">重要信息提醒</div>
            <div class="left-block-desc">开启通知，掌握即时消息</div>
          </div>
          <div class="right-block">马上开启</div>
        </div>
      </div>
    </div>

    <guide-info v-if="guideInfo"
                class="product-detail-member-notice-guide-info"
                :info="guideInfo"
                :type="type"
                :id="id"
    />

    <qr-code-popup :show.sync="showQrCode"
                   :title="qrCode.title"
                   :src="qrCode.src"
                   :hint="qrCode.hint"
    />

    <product-wechat-group-info :show.sync="showWeChatGroup"
                               :product="product[0]"
                               :user-info="userInfo"
    />

  </div>
</template>

<script>
  import GuideInfo from '@/pages/Pay/components/PayNotifyGuideInfo';
  import QrCodePopup from '@/components/QrCodePopup';
  import ProductWechatGroupInfo from '@/components/ProductWechatGroupInfo';
  import validator from '@/utils/validator';
  import { getProductWeChatGroupInfo } from '@/services/app';
  import { isAppWebView } from '@/utils';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'ProductDetailMemberNotice',
    components: {
      GuideInfo,
      QrCodePopup,
      ProductWechatGroupInfo,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      qrCode: {
        type: Object,
        validator(val) {
          return validator.isObject(val);
        },
      },
      wechatGroup: {
        type: Boolean,
        default: false,
      },
      guideInfo: {
        type: Object,
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
    data() {
      return {
        showQrCode: false,
        product: [],
        userInfo: null,
        showWeChatGroup: false,
      };
    },
    methods: {
      async handleClickWeChatGroup() {
        const params = { id: this.id, type: this.type };
        const data = await getProductWeChatGroupInfo(params);
        this.product = data.product;
        this.userInfo = data.userInfo;

        if (data.product.length > 1) {
          const { fullPath } = this.$route;
          this.$router.push({ name: 'MultiProductWeChatGroup', query: { redirectTo: fullPath } });
          return;
        }
        if (data.product.length) {
          this.showWeChatGroup = true;
          return;
        }
        this.$toast('暂无课程学习群信息');
      },
      handleClickQrCode() {
        const { qrCode: { src: qrCode, hint } } = this;
        if (qrCode === '') return;
        if (isAppWebView()) {
          locationToAppWithRoute({
            name: 'AppQrCodeDetail',
            params: {
              qrCode,
              hint,
            },
          });
          return;
        }
        this.showQrCode = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-member-notice {
    box-sizing: border-box;
    width: 100%;
    padding: @size-base;
    background: @color-white;
    border-bottom: @size-extra-small solid @background-color-base;

    &-receive-info-block-title {
      padding-bottom: @size-base;
      color: @color-text-base;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      line-height: 1;
    }
    &-receive-info-square-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-receive-info-square-wechat-group,
    &-receive-info-square-qr-code {
      box-sizing: border-box;
      padding: @size-small;
      width: 330px;
      height: 174px;
      .block-title {
        margin-bottom: 12px;
        font-size: @font-size-medium;
        line-height: 1;
        font-weight: @font-weight-bold;
      }
      .block-desc {
        margin-bottom: 22px;
        font-size: @font-size-extra-small;
        line-height: 1;
      }
      .block-action {
        float: right;
        width: 130px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: @font-size-extra-small;
        line-height: 1;
        border-radius: 22px;
      }
    }
    &-receive-info-square-wechat-group {
      background: url('~@/assets/img/combo/square_wechat_group.png');
      background-size: contain;
      .block-title {
        color: #ff8500;
      }
      .block-desc {
        color: #cfa567;
      }
      .block-action {
        background: #ff8500;
      }
    }
    &-receive-info-square-qr-code {
      background: url('~@/assets/img/combo/square_qr_code.png');
      background-size: contain;
      .block-title {
        color: #13b9bf;
      }
      .block-desc {
        color: #91b2b3;
      }
      .block-action {
        background: #02cccc;
      }
    }
    &-receive-info-rect-wechat-group,
    &-receive-info-rect-qr-code-group {
      box-sizing: border-box;
      padding: 0 @size-base;
      width: 690px;
      height: 110px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left-block {
        &-title {
          margin-bottom: 12px;
          font-size: @font-size-medium;
          line-height: 1;
          font-weight: @font-weight-bold;
        }
        &-desc {
          font-size: @font-size-extra-small;
          line-height: 1;
        }
      }
      .right-block {
        width: 160px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: @font-size-small;
        line-height: 1;
        border-radius: 30px;
      }
    }

    &-receive-info-rect-wechat-group {
      background: url('~@/assets/img/combo/rect_wechat_group.png') no-repeat;
      background-size: contain;
      .left-block {
        &-title {
          color: #ff8500;
        }
        &-desc {
          color: #cfa567;
        }
      }
      .right-block {
        background: #ff8500;
      }
    }

    &-receive-info-rect-qr-code-group {
      background: url('~@/assets/img/combo/rect_qr_code.png') no-repeat;
      background-size: contain;
      .left-block {
        &-title {
          color: #13b9bf;
        }
        &-desc {
          color: #91b2b3;
        }
      }
      .right-block {
        background: #02cccc;
      }
    }
  }

</style>
